import { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./UserComponent.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import { observer } from "mobx-react";
import config from "../../config/config";
import store from "../../Store/Store";
import { Button, Pagination } from "antd";
import EditUserLimits from "./EditUserLimits/EditUserLimits";
import NewUsers from "./newUsers/NewUsers";
import Notificatio from "./Notification/Notificatio";
import companyStore from "../../Store/Store";
import TopUp from "./TopUp/TopUp";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import NewUserPopup from "../Transaction/NewUserPopup/NewUserPopup";
import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDebouncedLog } from "../../useDebouncedLog";

const UserComponent = observer(({ className = "" }) => {
  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [serchFilter, setSerchFilter] = useState("");
  const [WalletInfo, setWalletinfo] = useState("Loading...");
  const [companyname, setcompanyname] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [flagNotifi, setFlagNotifi] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [refresh, setRefresh] = useState(true);
  const [editUser, setEdituser] = useState(false);
  const [EditTopUp, setEditTopUp] = useState(false);
  const [noData, setNoData] = useState(false);
  const [topUpNoti, settopUpNoti] = useState(false);
  const [isViewAdmin, setViewAdmin] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [advKycStatus, setAdvKycStatus] = useState("");
  const [whitelistingStatus, setWhitelistingStatus] = useState("");
  const [onboardingStatus, setOnboardingStatus] = useState("");
  const [userActionClicked, setUserActionClicked] = useState();
  const [copied, setCopied] = useState(false);
  const [kycStatus, setKycStatus] = React.useState("");
  const [kycStatusFilter, setKycStatusFilter] = React.useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [LinkCopied, setLinkCopied] = useState(false);
  const [LinkResend, setLinkResend] = useState(false);
  const [ResendReq, setResendReq] = useState(false);

  var logUserManagementVisited;
  var logCompanyDetailFetched;
  var logCupiUserFetched;
  var logResendKycLinkSend;
  var logKycLinkCopied;
  var logTopupOpen;
  var logEditUser;
  var logStartUserKyc;
  var logOpenTopUp;
  var logBulkUserClicked;
  var logAddAxisNewUserClicked;
  var logAddPineNewUserClicked;
  var logKycStatusFilterOpened;
  try {
    logUserManagementVisited = useDebouncedLog(
      "admin_users_screen_visited",
      500,
    );
    logCompanyDetailFetched = useDebouncedLog("admin_company_detail_fetched", 500);
    logCupiUserFetched = useDebouncedLog("admin_get_cupi_users_fetched", 500);
    logResendKycLinkSend = useDebouncedLog("admin_resend_kyc_link_send", 500);
    logKycLinkCopied = useDebouncedLog("admin_kyc_link_copied", 500);
    logTopupOpen = useDebouncedLog("admin_topup_opened", 500);
    logEditUser = useDebouncedLog("admin_edit_user_clicked", 500);
    logStartUserKyc = useDebouncedLog("admin_start_user_kyc");
    logOpenTopUp = useDebouncedLog("admin_open_top_up");
    logBulkUserClicked = useDebouncedLog("admin_bulk_user_clicked");
    logAddAxisNewUserClicked = useDebouncedLog("admin_axis_add_user_clicked");
    logAddPineNewUserClicked = useDebouncedLog("admin_pine_add_user_clicked");
    logKycStatusFilterOpened = useDebouncedLog("admin_kyc_status_opened");
  } catch (err) {
    console.log("error", err);
  }

  const DetailPopup = ({ data }) => {
    if (!data) return null;

    return (
      <div className={styles.detailPopup}>
        {Object.entries(data).map(
          ([key, value]) =>
            typeof value !== "object" &&
            value !== null && (
              <p key={key}>
                <strong>{formatKey(key)}:</strong> {value.toString()}
              </p>
            ),
        )}
      </div>
    );
  };

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  useEffect(() => {
    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      const obj = {
        ledger_label: store.Company_Id,
      };
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_cupi_company_detail`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((res) => {
          setWalletinfo(res.data.data);
          store.setInsightAvilable(res.data.data.metabase_account_created);
          try {
            logCompanyDetailFetched();
          } catch (er) {
            console.log("error%o", er);
          }
        })
        .catch((er) => {
          console.log("error-->", er);
        });
      setCompany(store.companyName);
    } catch (err) {
      console.log("Error in walletInfo", err);
    }
  }, [store.refresh]);

useEffect(()=>{
logUserManagementVisited()
},[logUserManagementVisited])

  useEffect(() => {
    if (!store.Company_Id) return;

    const fetchStatus = async () => {
      // setLoading(true);
      // setError("");
      try {
        let tokens = localStorage.getItem("authToken");
        let parsedTokens = JSON.parse(tokens);
        const res = await fetch(
          `${config.kyc_api_endpoint}/user/status?company_id=${store.Company_Id}`,
          {
            method: "POST", // ← changed to POST
            headers: {
              "Content-Type": "application/json",
              aws_cognito_id_token: parsedTokens.IdToken,
              aws_cognito_access_token: parsedTokens.AccessToken,
            },
            body: JSON.stringify({
              company_id: store.Company_Id,
              kyc_company_id: store.KycCompanyId,
            }),
          },
        );

        const data = await res.json();
        const statusMap = Object.fromEntries(
          data.status.map((s) => [s.key, s.value]),
        );
        console.log("RESPONSE_________>", data);

        setAdvKycStatus(statusMap["advanced-kyc"]);
        setWhitelistingStatus(statusMap["whitelisting"]);
        setOnboardingStatus(data.onboarding_status);
        store.setCompTempId(data.company_id);
        store.setKycCompanyId(data?.company_id);
        store.setTradeName(data.trade_name);
        if (!res.ok || !data.success) {
          throw new Error(data.error || "Failed to fetch status");
        }

        // setStatus(data.status);
        // setOnboardingStatus(data.onboarding_status);
      } catch (err) {
        if (err.name !== "AbortError") {
          // setError(err.message || "Something went wrong");
        }
      } finally {
        // setLoading(false);
      }
    };

    fetchStatus();
  }, [store.company_temp_id, store.refresh]);

  useEffect(() => {
    store.setSelectedExpenseMobileNo("");
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    const obj = {
      ledger_label: store.Company_Id,
    };
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    const expired = isTokenExpired(parsedTokens.IdToken);
    if (expired) {
      parsedTokens = getNewTokens(parsedTokens);
    }
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_compnay_users`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    axios
      .request(payload)
      .then((res) => {
        setData(res.data.data);
        setcompanyname(res.data.company_name);
        try {
          logCupiUserFetched();
        } catch (err) {
          console.log("error", err);
        }
      })
      .catch((er) => {
        console.log(er);
      });
  }, [refresh, store.refresh]);

  const handlenavi = () => {
    navigate("/content/view-user");
  };

  const getKycStatus = (user) => {
    if (user?.has_wallet) return "Completed";

    const status = user?.kyc_info?.initiate_kyc_bp_response?.status;

    if (status === "kyc_initiated") return "kyc_initiated";
    if (status === "kyc_link_expired") return "kyc_link_expired";

    // fallback cases
    if (!user?.has_wallet) return "NA";
    return "N/A";
  };
  const filteredData = data.filter((user) => {
    // Search (case-insensitive)
    const searchLower = serchFilter.toLowerCase();
    const matchesSearch =
      !serchFilter ||
      [user.name, user.mobile_no, user.email, user.tags].some((field) =>
        field?.toLowerCase().includes(searchLower),
      ) ||
      user?.roles?.includes(serchFilter.toUpperCase());

    // KYC filter
    const userKycStatus = getKycStatus(user);
    const matchesKyc = !kycStatus || userKycStatus === kycStatus;

    return matchesSearch && matchesKyc;
  });

  // Optional: sort newest first (most common for user lists)
  // const sortedFiltered = [...filteredData].sort((a, b) => {
  //   // Example: sort by created_at or id descending
  //   return new Date(b.created_at || 0) - new Date(a.created_at || 0);
  //   // or: return b.id - a.id;
  // });

  const startIndex = (currentPage - 1) * pageSize;
  const currentPageData = filteredData
    .reverse()
    .slice(startIndex, startIndex + pageSize);

  useEffect(() => {
    if (currentPageData.length < 1) {
      setNoData(true);
    } else {
      setNoData(false);
    }
  }, [currentPageData]);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const onAddNewUsersClick = useCallback(() => {
    setFlag(true);
  }, []);

  function OpenTopup(detail) {
    try {
      console.log("detail?----->", detail);

      store.setUserId(detail.user_id);
      store.setName(detail.name);
      store.setSelectedEmail(detail.email);
      store.setCreate_at(detail.create_at);
      store.setPhoneNo(detail?.mobile_no);
      store.setUserRoles(detail?.roles);
      console.log("detail?.topup_startdate", detail.topup_startdate);
      console.log(
        "hasTopup",
        detail?.topup_startdate != undefined &&
          detail.topup_enddate != undefined &&
          detail?.topup_startdate != "" &&
          detail.topup_enddate != "",
      );
      if (
        detail?.topup_startdate != undefined &&
        detail.topup_enddate != undefined &&
        detail?.topup_startdate != "" &&
        detail.topup_enddate != ""
      ) {
        console.log("topUp is available");

        store.setTopUpStatus(detail?.topup_status);
        store.setTopUpName(detail?.topup_name);
        store.setTopUpTotalLimit(detail?.topup_total_limit);
        store.setTopUpDailyLimit(detail?.topup_daily_limit);
        store.setTopUpNote(detail?.topup_note ? detail?.topup_note : "");
        store.setStartDate(detail?.topup_startdate);
        store.setEndDate(detail?.topup_enddate);
      } else {
        store.setTopUpStatus("");
        store.setTopUpName("");
        store.setTopUpTotalLimit("");
        store.setTopUpDailyLimit("");
        store.setTopUpNote("");
        store.setStartDate("");
        store.setEndDate("");
      }
      try {
        logTopupOpen();
      } catch (err) {
        console.log("error%o", err);
      }
      setEditTopUp(true);
    } catch (err) {
      console.log("error", err);
    }
  }

  const copyToClipboard = async (linkToCopy) => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      setCopied(true);

      // Optional: reset after 2 seconds
      setTimeout(() => setCopied(false), 2000);
      try {
        logKycLinkCopied();
      } catch (er) {
        console.log("error%o", er);
      }
    } catch (err) {
      console.error("Failed to copy:", err);
      setCopied(false);
    }
  };
  function removePlus91(number) {
    if (!number) return number;

    return number
      .trim()
      .replace(/\s+/g, "")
      .replace(/^(?:\+91|91|0091|091|\+0091)/, "")
      .replace(/^0+/, ""); // optional: remove leading zeros too
  }
  console.log("removePlus91");

  const resendKycLink = async (detail) => {
    try {
      console.log("details----->", detail);
      const rawAuth = localStorage.getItem("authToken");
      let parsedTokens = rawAuth ? JSON.parse(rawAuth) : {};
      let ParsedNUmber = removePlus91(detail?.mobile_no);
      let obj = {
        initiate_kyc_bp_response: detail?.kyc_info?.initiate_kyc_bp_response,
        kyc_initiate_on: detail?.kyc_info?.kyc_initiate_on,
        user_mobile_no: ParsedNUmber,
        ledger_label: store.Company_Id,
      };
      const expired = isTokenExpired(parsedTokens?.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/refresh_expired_link_and_resend_kyc_link`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };
      axios
        .request(payload)
        .then((res) => {
          setResendReq(true);
          // GetkycStatus("Expired");
          try {
            logResendKycLinkSend();
          } catch (err) {
            console.log("error%o", err);
          }
        })
        .catch((err) => {
          console.log("error: %o".err);
        });
    } catch (err) {
      console.log("err", err);
    }
  };

  function getKycDisplayStatus(detail) {
    if (detail.has_wallet) {
      return "Completed";
    }

    const status = detail?.kyc_info?.initiate_kyc_bp_response?.status;

    if (detail?.kyc_info?.kyc_initiate_on && status === "kyc_initiated") {
      return "Pending";
    }

    if (status === "kyc_link_expired") {
      return "Expired";
    }

    if (!detail.has_wallet) {
      return "NA";
    }

    return "N/A";
  }
  return (
    <div
      className={styles.pageContainer + " " + className}
      onClick={() => {
        setUserActionClicked();
      }}
    >
      <div className={styles.frameParent}>
        <div className={styles.cards16pxContainer111}>
          <div className={styles.cards16pxContainer}>
            {companyStore.userType != "AxisUser" && (
              <div className={styles.cards16px}>
                <div className={styles.saveMoney1044644423Parent}>
                  <div className={styles.saveMoney1044644423}>
                    <img
                      className={styles.vectorIcon}
                      alt=""
                      src="/vector.svg"
                    />
                  </div>
                  <div className={styles.availableBalanceParent}>
                    <div className={styles.availableBalance}>
                      Available Balance*
                    </div>
                    <div className={styles.div}>
                      ₹{WalletInfo.balance || "Loading..."}
                    </div>
                  </div>
                </div>

                {store.Company_Id != "AxisDemo" && (
                  <div className={styles.saveMoney1044644423Parent1}>
                    <div className={styles.saveMoney1044644423row}>
                      <div className={styles.saveMoney1044644423}>
                        <img
                          className={styles.vectorIcon}
                          alt=""
                          src="/wallet.svg"
                        />
                      </div>
                      <div className={styles.availableBalanceParent1}>
                        <div className={styles.availableBalance}>
                          Account Details*
                          <div className={styles.tiptool}>
                            {/* <img
                              src="/alert-circle.svg"
                              alt=""
                              className={styles.icon}
                            />
                            <span className={styles.Texttooltip}>
                              Please load money only from company's validated
                              Bank account to the wallet.
                            </span> */}
                          </div>
                        </div>

                        <div className={styles.div16}>
                          <div>Ac.no</div>
                          <div>:</div>
                          <div>{WalletInfo?.van?.acc_no || "Loading..."}</div>
                        </div>
                        <div className={styles.div16}>
                          <div>IFSC</div>
                          <div>:</div>
                          <div>{WalletInfo?.van?.ifsc || "Loading..."}</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={styles.RedirectLink}
                      onClick={() => {
                        navigate("/content/kycValidation?tab=2");
                      }}
                    >
                      How to load money? Click here
                    </div>
                  </div>
                )}
              </div>
            )}
            {companyStore.userType == "AxisUser" && (
              <div className={styles.welcomesunshineinfotechWrapper}>
                <div className={styles.welcomesunshineinfotech}>
                  {companyStore.userType == "AxisUser" &&
                    !store.isUserViewAdmin &&
                    !store.isUserGlobalViewAdmin && (
                      <button
                        className={styles.addNewUsers}
                        onClick={() => {
                          navigate("/content/bulkUser");
                          try {
                            logBulkUserClicked();
                          } catch (err) {
                            console.log("error", err);
                          }
                        }}
                      >
                        <img
                          className={styles.plusCircleIcon}
                          alt=""
                          src="/Layer_14.svg"
                        />
                        <b className={styles.newUser}>Bulk users </b>
                      </button>
                    )}

                  {companyStore.userType == "AxisUser" &&
                    !store.isUserViewAdmin &&
                    !store.isUserGlobalViewAdmin && (
                      <button
                        className={styles.addNewUsers}
                        onClick={() => {
                          onAddNewUsersClick();
                          try {
                            logAddAxisNewUserClicked();
                          } catch (err) {
                            console.log("error", err);
                          }
                        }}
                      >
                        <img
                          className={styles.plusCircleIcon}
                          alt=""
                          src="/pluscircle.svg"
                        />
                        <b className={styles.newUser}>New user</b>
                      </button>
                    )}
                </div>
              </div>
            )}
            {!showBanner && companyStore.userType != "AxisUser" && (
              <NewUserPopup
                advKycStatus={advKycStatus}
                whitelistingStatus={whitelistingStatus}
                onboardingStatus={onboardingStatus}
                setShowBanner={setShowBanner}
                showOthers={false}
              />
            )}
          </div>
          {LinkCopied && (
            <div className={styles.Copylink}>
              <img
                className={styles.linkCopied}
                alt=""
                src="/check-circle.svg"
              />
              KYC Link have been Copied.
            </div>
          )}
          {LinkResend && (
            <div className={styles.Copylink}>
              <img
                className={styles.linkCopied}
                alt=""
                src="/check-circle.svg"
              />
              KYC Link have been Resent.
            </div>
          )}
        </div>
        <div className={styles.frameGroup}>
          <div className={styles.feeStatementDataTable}>
            <div className={styles.top}>
              <div className={styles.filterWrapper}>
                <div className={styles.filter}>
                  <div className={styles.containertext}> User List</div>{" "}
                </div>
                <div className={styles.filter}>
                  {companyStore.userType != "AxisUser" &&
                    (store.isUserOwner || store.isUserAdmin) && (
                      <button
                        className={styles.addNewUsers}
                        onClick={() => {
                          onAddNewUsersClick();
                          try {
                            logAddPineNewUserClicked();
                          } catch (err) {
                            console.log("error", err);
                          }
                        }}
                      >
                        <img
                          className={styles.plusCircleIcon}
                          alt=""
                          src="/pluscircle.svg"
                        />
                        <b className={styles.newUser}>Add New User</b>
                      </button>
                    )}
                  <div className={styles.textField}>
                    <div className={styles.content}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/leadingicon.svg"
                      />
                      <input
                        className={styles.labelText1}
                        placeholder="Search..."
                        type="text"
                        value={serchFilter}
                        onChange={(e) => {
                          setSerchFilter(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className={styles.FilterField}
                    onClick={() => {
                      setOpenFilter(true);
                      try {
                        logKycStatusFilterOpened();
                      } catch (err) {
                        console.log("error", err);
                      }
                    }}
                  >
                    <div className={styles.content1}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/filter-lines.svg"
                      />
                      Filter
                    </div>
                  </div>
                  {openFilter && (
                    <div className={styles.filterPopup}>
                      <div className={styles.FilterHeading}>
                        <div>Filters</div>
                        <div
                          onClick={() => {
                            setOpenFilter(false);
                          }}
                          className={styles.FilterCloseIcon}
                        >
                          <img
                            className={styles.leadingIcon2}
                            alt=""
                            src="/XCircle.svg"
                          />
                        </div>
                      </div>
                      <div>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth>
                            <InputLabel id="kyc-status-label">
                              Kyc Status
                            </InputLabel>
                            <Select
                              labelId="kyc-status-label"
                              id="kyc-status"
                              value={kycStatusFilter}
                              label="Kyc Status"
                              onChange={(event) => {
                                setKycStatusFilter(event.target.value);
                              }}
                            >
                              <MenuItem value={"kyc_initiated"}>
                                Pending
                              </MenuItem>
                              <MenuItem value={"kyc_link_expired"}>
                                Expired
                              </MenuItem>
                              <MenuItem value={"rejected"}>Rejected</MenuItem>
                              <MenuItem value={"Completed"}>Completed</MenuItem>
                              <MenuItem value={"NA"}>NA</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </div>
                      <div className={styles.filterPopupBtnContainer}>
                        <button
                          className={styles.filterPopupBtn}
                          onClick={() => {
                            setKycStatus(kycStatusFilter);
                            setOpenFilter(false);
                          }}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}
                  <button
                    className={styles.reLoadTable}
                    onClick={() => {
                      setKycStatus("");
                      setOpenFilter(false);
                      setKycStatusFilter("");
                      if (refresh) {
                        setRefresh(false);
                        return;
                      }
                      setRefresh(true);
                    }}
                  >
                    <img
                      className={styles.vectorIcon1}
                      alt=""
                      src="/vector7.svg"
                    />
                  </button>
                </div>
              </div>
              <div className={styles.topChild} />
            </div>
            <table className={styles.table}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeaderRow}>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>NAME</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>PHONE NO</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>EMAIL</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`PER TXN LIMIT (₹)`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`DAILY LIMIT(₹)`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`MONTHLY LIMIT(₹)`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`Top-up status`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`Roles`}</div>
                  </th>
                  {store.userType != "AxisUser" && (
                    <th className={styles.tableHeaderRowCell}>
                      <div className={styles.head1}>{`KYC status`}</div>
                    </th>
                  )}
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head1}>ACTION</div>
                  </th>
                </tr>
              </thead>
              <tbody className={styles.tableHead}>
                {currentPageData.map((detail, index) => {
                  detail.has_wallet
                    ? (detail.Kyc_status = "Completed")
                    : detail?.kyc_info?.kyc_initiate_on &&
                        detail?.kyc_info?.initiate_kyc_bp_response?.status ==
                          "kyc_initiated"
                      ? (detail.Kyc_status = "Pending")
                      : detail?.kyc_info?.initiate_kyc_bp_response?.status ==
                          "kyc_link_expired"
                        ? (detail.Kyc_status = "Expired")
                        : !detail?.has_wallet
                          ? (detail.Kyc_status = "NA")
                          : (detail.Kyc_status = "N/A");
                  return (
                    <tr key={index} className={styles.tableBodyrow}>
                      <td
                        className={styles.tableBodydatabtn}
                        onClick={() => {
                          console.log("gotit");
                          store.setSelectedExpenseMobileNo(detail.mobile_no);
                          navigate("/content/transactions");
                        }}
                      >
                        <div className={styles.data12}>{detail?.name}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data1}>{detail?.mobile_no}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data1}>
                          {detail?.email == "undefined"
                            ? "-"
                            : detail?.email || "-"}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data}>{detail.perTxnLimit}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data}> {detail.dailyLimit} </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data}>{detail.monthlyLimit}</div>
                      </td>
                      <td className={styles.tableBodydata}>
                        {" "}
                        <div className={styles.data}>
                          {detail?.topup_status || "inactive"}
                        </div>
                      </td>
                      <td className={styles.tableBodydata}>
                        <div className={styles.data}>
                          {detail.roles.includes("OWNER")
                            ? "Owner"
                            : detail.roles.includes("ADMIN")
                              ? "Admin"
                              : detail.roles.includes("CUPI_VIEW_ADMIN")
                                ? "Viewer"
                                : detail.roles.includes("CUPI_COMPANY_EMPLOYEE")
                                  ? "User"
                                  : "NA"}
                        </div>
                      </td>

                      {store.userType != "AxisUser" && (
                        <td className={styles.tableBodydata}>
                          {store.isUserOwner &&
                          !detail.has_wallet &&
                          !detail?.kyc_info?.initiate_kyc_bp_response
                            ?.status ? (
                            <div
                              className={styles.StartKycButton}
                              onClick={() => {
                                // ── populate store ───────────────────────────────────────
                                store.setUserId(detail.user_id);
                                store.setName(detail.name);
                                store.setSelectedEmail(detail.email);
                                store.setTxnLimit(detail.perTxnLimit);
                                store.setDailyLimit(detail.dailyLimit);
                                store.setmonthlyLimit(detail.monthlyLimit);
                                store.setCreate_at(detail.create_at);
                                store.setPhoneNo(detail.mobile_no);
                                store.setStatus(detail.status);
                                store.setEnabled(true);
                                store.setUserRoles(detail.roles);
                                store.setTags(detail.tags?.split(",") ?? []);

                                if (companyStore.userType !== "AxisUser") {
                                  store.setUserHasWallet(detail.has_wallet);
                                  store.setUserKycInfo(detail.kyc_info);
                                }

                                setEdituser(true);
                                try {
                                  logStartUserKyc();
                                } catch (err) {
                                  console.log("error", err);
                                }
                              }}
                            >
                              Start KYC
                            </div>
                          ) : (
                            <div className={styles.data11}>
                              {getKycDisplayStatus(detail)}
                            </div>
                          )}
                        </td>
                      )}
                      <td className={styles.tableBodydata22}>
                        <buton
                          onClick={(e) => {
                            //Open Popup
                            e.stopPropagation();
                            // if (
                            //   !store.isUserViewAdmin &&
                            //   !store.isUserGlobalViewAdmin
                            // ) {
                              setUserActionClicked({
                                user_id: detail?.user_id,
                                mobile_no: detail?.mobile_no,
                              });
                            // }
                          }}
                        >
                          <img src="/ActionBtn.svg" />
                        </buton>
                        {detail?.user_id == userActionClicked?.user_id &&
                          detail?.mobile_no == userActionClicked?.mobile_no && (
                            <div
                              className={styles.ActionPopup}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* COPY KYC LINK */}
                              {detail.Kyc_status == "Pending" && (
                                <div
                                  className={styles.ActionPopupInnerDiv}
                                  onClick={async (e) => {
                                    e.stopPropagation();

                                    setUserActionClicked();
                                    copyToClipboard(
                                      detail?.kyc_info?.initiate_kyc_bp_response
                                        ?.kycLink?.webLink,
                                    );
                                    console.log("Link Copied");

                                    setLinkCopied(true);
                                    await new Promise((resolve) =>
                                      setTimeout(resolve, 1500),
                                    );
                                    setLinkCopied(false);
                                  }}
                                >
                                  Copy KYC Link
                                </div>
                              )}
                              {/* RESEND KYC LINK */}
                              {(!store.isUserViewAdmin &&
                            !store.isUserGlobalViewAdmin)&&(detail.Kyc_status == "Rejected" ||
                                detail.Kyc_status == "Expired") && (
                                <div
                                  className={styles.ActionPopupInnerDiv}
                                  onClick={async (e) => {
                                    setUserActionClicked();
                                    e.stopPropagation();
                                    resendKycLink(detail);

                                    setLinkResend(true);
                                    await new Promise((resolve) =>
                                      setTimeout(resolve, 1500),
                                    );
                                    setLinkResend(false);
                                  }}
                                >
                                  Resend KYC Link
                                </div>
                              )}

                              {detail.Kyc_status == "Completed" && (
                                <div
                                  className={styles.ActionPopupInnerDiv}
                                  onClick={(e) => {
                                    setUserActionClicked();
                                    e.stopPropagation();
                                    OpenTopup(detail);
                                    try {
                                      logOpenTopUp();
                                    } catch (err) {
                                      console.log("error%o", err);
                                    }
                                  }}
                                >
                                  Add Top-Up
                                </div>
                              )}

                              <div
                                className={styles.ActionPopupInnerDiv}
                                onClick={(e) => {
                                  setUserActionClicked();
                                  e.stopPropagation();

                                  store.setUserId(detail?.user_id);
                                  store.setName(detail?.name);
                                  store.setSelectedEmail(detail?.email);
                                  store.setTxnLimit(detail?.perTxnLimit);
                                  store.setDailyLimit(detail?.dailyLimit);
                                  store.setmonthlyLimit(detail?.monthlyLimit);
                                  store.setCreate_at(detail?.create_at);
                                  store.setPhoneNo(detail?.mobile_no);
                                  store.setStatus(detail?.status);
                                  store.setEnabled(true);
                                  store.setUserRoles(detail?.roles);
                                  store.setTags(detail?.tags?.split(","));
                                  if (companyStore.userType != "AxisUser") {
                                    store.setUserHasWallet(detail?.has_wallet);
                                    store.setUserKycInfo(detail?.kyc_info);
                                  }

                                  setEdituser(true);
                                  try {
                                    logEditUser();
                                  } catch (err) {
                                    console.log("error", err);
                                  }
                                }}
                              >
                                Edit User
                              </div>
                            </div>
                          )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {noData && <div className={styles.noHistory}>No Users found .</div>}
            <div className={noData ? styles.bottom1 : styles.bottom}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={filteredData.length}
                onChange={handlePaginationChange}
                // showSizeChanger
              />
            </div>
          </div>
        </div>
      </div>
      <div></div>
      {editUser && (
        <div
          className={styles.ViewUserHeader}
          onClick={() => {
            // setEdituser(false);
          }}
        >
          <EditUserLimits
            isVisible={editUser}
            onClose={() => {
              setEdituser(false);
            }}
          />
        </div>
      )}
      {flag && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            // setFlag(false);
          }}
        >
          <NewUsers
            isVisible={flag}
            onClose={() => {
              setFlag(false);
            }}
            openNoti={() => {
              setFlagNotifi(true);
            }}
            setAdmin={() => {
              setIsAdmin(true);
            }}
            resetAdmin={() => {
              setIsAdmin(false);
            }}
            setViewAdmin={() => {
              setViewAdmin(true);
            }}
            setUserAccess={() => {
              setIsUser(true);
              console.log("NEW USER HAS BEEN ADDED");
            }}
          />
        </div>
      )}
      {EditTopUp && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            // setEditTopUp(false);
          }}
        >
          <TopUp
            isVisible={EditTopUp}
            onClose={() => {
              setEditTopUp(false);
            }}
            openNoti={() => {
              setFlagNotifi(true);
              settopUpNoti(true);
              if (refresh) {
                setRefresh(false);
              } else {
                setRefresh(true);
              }
            }}
          />
        </div>
      )}
      {flagNotifi && (
        <div
          className={styles.newUsersOverlay1}
          onClick={() => {
            setFlagNotifi(false);

            settopUpNoti(false);
          }}
        >
          <Notificatio
            isAdmin={isAdmin}
            isVisible={flagNotifi}
            onClose={() => {
              setFlagNotifi(false);
            }}
            TopUpNoti={topUpNoti}
            isViewAdmin={isViewAdmin}
            isUser={isUser}
          />
        </div>
      )}
    </div>
  );
});

UserComponent.propTypes = {
  className: PropTypes.string,
};

export default UserComponent;
